module.exports = __webpack_public_path__ + "img/cloudinary-1.82dccb30.jpg";